export default __webpack_public_path__ + "9ff793a1729fed811940a839664c9a00.svg";